module.exports = __webpack_public_path__ + "assets/sentiment_neutral_grey.6cbe950d.svg";